// extracted by mini-css-extract-plugin
module.exports = {"bloc":"CartReinsurance_bloc__tD1UN","container":"CartReinsurance_container__1mcIH","message":"CartReinsurance_message__2zoRn","title":"CartReinsurance_title__doDwN"};